import { Controller } from "@hotwired/stimulus"

// 품목 상세 모달.
//
// 네이티브 <dialog> 를 쓴다. 포커스 가두기·ESC 닫기·스크롤 잠금을 브라우저가
// 대신 해 주므로 직접 만든 오버레이보다 접근성이 낫다.
//
// 링크를 누르면 곧바로 열고(로딩 표시), 내용은 Turbo Frame 이 뒤이어 채운다.
// 프레임 로드 이벤트를 기다렸다 열면 느린 회선에서 한참 아무 반응이 없어 보인다.
export default class extends Controller<HTMLElement> {
  static targets = ["dialog", "frame", "loading"]

  declare readonly dialogTarget: HTMLDialogElement
  declare readonly frameTarget: HTMLElement
  declare readonly loadingTarget: HTMLElement
  declare readonly hasDialogTarget: boolean
  declare readonly hasFrameTarget: boolean
  declare readonly hasLoadingTarget: boolean

  // 링크 클릭 시 즉시 연다. Turbo 가 같은 클릭으로 프레임을 채운다.
  open(): void {
    if (!this.hasDialogTarget) return

    this.showLoading()
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  close(): void {
    if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close()
  }

  // 배경을 눌렀을 때만 닫는다. 카드 안을 눌러 닫히면 안 된다.
  closeOnBackdrop(event: MouseEvent): void {
    if (this.hasDialogTarget && event.target === this.dialogTarget) this.close()
  }

  // 내용이 도착하면 로딩 표시를 감춘다.
  loaded(): void {
    if (this.hasLoadingTarget) this.loadingTarget.hidden = true
  }

  // 닫힌 뒤 프레임을 비운다. 안 그러면 같은 품목을 다시 눌렀을 때
  // Turbo 가 이미 로드된 프레임이라 보고 아무것도 하지 않는다.
  onClose(): void {
    if (!this.hasFrameTarget) return

    this.frameTarget.innerHTML = ""
    this.frameTarget.removeAttribute("src")
    this.frameTarget.removeAttribute("complete")
  }

  private showLoading(): void {
    if (this.hasLoadingTarget) this.loadingTarget.hidden = false
  }
}
